/**
 * @type {ChatBotModal}
 */
let chatBotComponent = null;


export const startChatBot = (action) => {
    console.log('start Chat Bot');
    chatBotComponent.resetChat();
    chatBotComponent.show();
    chatBotComponent.startChat();
}

export const startChatBotFromSearch = (uuid, action) => {
    console.log('start Chat Bot');
    chatBotComponent.resetChat();
    chatBotComponent.show();
    chatBotComponent.addSilenaMessage($tr('chatBot.what.searching','What are you searching for?'));
    chatBotComponent.addUserMessage(action.query);
    chatBotComponent.addSilenaMessage($tr('chatBot.let.help','OK, let me help you.'));
    chatBotComponent.continueChat(uuid, "");

}

export const registerChatBotComponent = (instance) => {
    chatBotComponent = instance;
}